import {
  U3101_HOUR_BANK_TYPES,
  type U3101HourBankBulkCloneMode,
  type U3101HourBankBulkClonePayload,
  type U3101HourBankType,
} from '../U3101Service';

export type U3101HourBankBulkBankDraft = {
  initialHours: string;
  overrideEmployee: boolean;
};

export type U3101HourBankBulkCloneBuildResult =
  | { ok: true; payload: U3101HourBankBulkClonePayload }
  | { ok: false; error: 'invalidInitial' };

export function u3101BuildHourBankBulkClonePayload(
  mode: U3101HourBankBulkCloneMode,
  drafts: Record<U3101HourBankType, U3101HourBankBulkBankDraft>,
): U3101HourBankBulkCloneBuildResult {
  if (mode === 'fromPrevious') {
    return { ok: true, payload: { mode: 'fromPrevious' } };
  }
  const banks: {
    bankType: U3101HourBankType;
    initialHours: number;
    overrideEmployee: boolean;
  }[] = [];
  for (const bankType of U3101_HOUR_BANK_TYPES) {
    const raw = String(drafts[bankType].initialHours ?? '')
      .trim()
      .replace(',', '.');
    const n = Number(raw);
    if (raw === '' || Number.isNaN(n) || n < 0) {
      return { ok: false, error: 'invalidInitial' };
    }
    banks.push({
      bankType,
      initialHours: n,
      overrideEmployee: drafts[bankType].overrideEmployee === true,
    });
  }
  return { ok: true, payload: { mode: 'custom', banks } };
}
